<template>
    <v-navigation-drawer
      :right="!$vuetify.rtl"
      app
      v-model="inputDrawer"
      stateless
      :width="1000"
      temporary
    >
    <div align="left" class="px-3 py-3">
      <v-btn
        fab
        @click="closeShowDrawer"
        small
        elevation="4"
        color="white"
        :ripple="false"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>
    <slot name="formDetails"></slot>
  </v-navigation-drawer>
</template>


<script>

export default {
  data() {
    return {
      //
    };
  },
  computed: {
    inputDrawer: {
      get () {
        return  this.$store.getters.showDrawer
      },
      set (value) {
        this.$store.commit('SHOW_RIGHTSIDE_DRAWER', value)
      }
    }
  },
  mounted () {
    //
  },
  methods: {
    closeShowDrawer () {
      this.$store.commit('SHOW_RIGHTSIDE_DRAWER', false)
      this.$store.commit("IS_EDIT_LANDLORD", false)
      this.$store.commit("IS_EDIT_AREA", false)
      this.$store.commit("IS_EDIT_FACILITY", false);
      this.$store.commit("IS_EDIT_BLOCK", false)
      this.$store.commit("IS_EDIT_BLOCK", false)
      this.$store.commit("IS_EDIT_CONTACT_US", false)
      this.$store.commit("IS_EDIT_UNIT", false)
      this.$store.commit("IS_EDIT_UNIT_TYPE", false)
      this.$store.commit("IS_EDIT_PROPERTY", false);
      this.$store.commit("IS_EDIT_PROPERTY_TYPE", false);
      this.$store.commit("IS_EDIT_BOOKING", false);
      this.$store.commit("IS_EDIT_LANDMARK", false);
      this.$store.commit('IS_REQUEST_LANDLORD', false)
      this.$store.commit("IS_ADMIN_PROFILE", false);
      this.$store.commit("IS_EDIT_CUSTOMER", false);
      this.$store.commit("IS_EDIT_PROMOTION", false);
      this.$store.commit("IS_EDIT_CONTRACT", false);
      this.$store.commit("IS_EDIT_CURRENCY", false);
      this.$store.commit("IS_EDIT_LANDLORD_VALIDITY_PLAN", false)
    }
  },
};
</script>
